export default function isInClause(parentClause, childClause) {
  return (
    parentClause === childClause || childClause.startsWith(`${parentClause}.`)
  );
}
